<template>
	<div class="main system">
		<div class="g-mnc g-mnc-kefu">
			<div class="sidebar">
				<div class="service-content">
					<el-col :span="24">
						<el-menu
							:default-active="key"
							class="el-menu-vertical-demo"
							@open="handleOpen"
							@close="handleClose"
							@select="handleSelect"
						>
							<el-menu-item index="1">
								<span slot="title">实时数据</span>
							</el-menu-item>
							<el-submenu index="2">
								<template slot="title">
									<span>历史数据</span>
								</template>
								<el-menu-item index="2-1">总览</el-menu-item>
								<el-menu-item index="2-2">坐席报表</el-menu-item>
								<el-menu-item index="2-3">留言报表</el-menu-item>
							</el-submenu>
							<el-menu-item index="3">
								<span slot="title">会话记录</span>
							</el-menu-item>
							<el-menu-item index="4">
								<span slot="title">留言记录</span>
							</el-menu-item>
						</el-menu>
					</el-col>
				</div>
			</div>
			<div class="content">
				<div :is="movement" @children="updData" @clareInitData="clareInitData1" :initData="childerData"></div>
			</div>
		</div>
	</div>
</template>
<script>
import realdata from '@/components/manage/system/realdata'
import overview from '@/components/manage/system/overview'
import report from '@/components/manage/system/report'
import Messagerecord from '@/components/manage/system/Message record'
import Record_the_session from '@/components/manage/system/Record_the_session'
import lyreport from '@/components/manage/system/lyreport'
export default {
	name: 'system',
	props: [],
	data() {
		return {
			movement: 'realdata',
			childerData: {},
			key: '1'
		}
	},
	watch: {},
	mounted: function() {},
	methods: {
		handleOpen(key, keyPath) {
			console.log(key, keyPath)
		},
		handleClose(key, keyPath) {
			console.log(key, keyPath)
		},
		handleSelect(key, keyPath) {
			console.log(key, keyPath)
			if (key == '1') {
				this.movement = 'realdata' //实时数据
			} else if (key == '2-1') {
				this.movement = 'overview' //总览
			} else if (key == '2-2') {
				//坐席报表
				this.movement = 'report'
			} else if (key == '2-3') {
				//留言报表
				this.movement = 'lyreport'
			} else if (key == '3') {
				//会话记录
				this.movement = 'Record_the_session'
			} else if (key == '4') {
				//留言记录
				this.movement = 'Messagerecord'
			}
			this.key = key
		},
		updData(data) {
			let vm = this
			vm.handleSelect(data.index)
			vm.childerData = data
		},
		clareInitData1() {
			this.childerData = {}
		}
	},
	components: {
		Messagerecord,
		Record_the_session,
		realdata,
		overview,
		report,
		lyreport
	}
}
</script>

<style scoped>
.main {
	flex: 1;
	display: flex;
	flex-direction: column;
	height: calc(100% - 65px);
	position: relative;
	background-color: #fff;
}
.g-mnc {
	display: flex;
	flex: 1;
	flex-direction: row;
	padding: 40px;
	box-sizing: border-box;
}
.g-mnc-kefu {
	position: relative;
	-moz-border-radius: 2px;
	border-radius: 2px;
	box-sizing: border-box;
	flex-direction: column;
	height: calc(40%);
	padding: 0 0 0 0px;
	display: flex;
	flex-direction: row;
}
.content-main {
	display: flex;
	position: relative;

	height: 100%;
}
.g-mnc-kefu .sidebar {
	height: 100%;
}
.service-content {
	width: 210px;
	transition: width 0.2s;
	background: #f7f8fa;
	overflow-x: hidden;
	overflow-y: auto;
	height: 100%;
}
.tabs > div {
	background-color: #f7f8fa;
	line-height: 50px;
	padding-left: 20px;
}
.tabs div.current {
	background-color: #edeef0;
	color: #337eff;
	border-right: 3px solid #337eff;
}
.el-menu-item.is-active {
	border-right: 3px solid #337eff;
}
.g-mnc-kefu .content {
	height: 100%;
	overflow: auto;
	display: flex;
	flex-direction: column;
	position: relative;
	/* padding: 0 30px; */
	padding-left: 30px;
	padding-top: 10px;
	width: 100%;
	box-sizing: border-box;
}
.contains {
	height: 100%;
	overflow: auto;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	position: relative;
	padding-top: 10px;
	width: 100%;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/manage/system/system.vue